export default {
  "mainVegetable": "zoldsegek",
  "mainVegetable/01": "zoldsegek/padlizsan",
  "mainVegetable/02": "zoldsegek/sparga",
  "mainVegetable/03": "zoldsegek/avokado",
  "mainVegetable/04": "zoldsegek/cekla",
  "mainVegetable/05": "zoldsegek/brokkoli",
  "mainVegetable/06": "zoldsegek/sargarepa",
  "mainVegetable/07": "zoldsegek/zeller",
  "mainVegetable/08": "zoldsegek/gomba",
  "mainVegetable/09": "zoldsegek/fejes-kaposzta",
  "mainVegetable/10": "zoldsegek/kelbimbo",
  "mainVegetable/11": "zoldsegek/kinai-kaposzta",
  "mainVegetable/12": "zoldsegek/karfiol",
  "mainVegetable/13": "zoldsegek/kaposzta",
  "mainVegetable/14": "zoldsegek/uborka",
  "mainVegetable/15": "zoldsegek/cukkini",
  "mainVegetable/16": "zoldsegek/endivia",
  "mainVegetable/17": "zoldsegek/spenot",
  "mainVegetable/18": "zoldsegek/lobab",
  "mainVegetable/19": "zoldsegek/flageolet-bab",
  "mainVegetable/20": "zoldsegek/lapos-bab",
  "mainVegetable/21": "zoldsegek/szaraz-bab",
  "mainVegetable/22": "zoldsegek/zoldhuvelyu-bab",
  "mainVegetable/23": "zoldsegek/lencse",
  "mainVegetable/24": "zoldsegek/zoldsegkeverek",
  "mainVegetable/25": "zoldsegek/csemegekukorica",
  "mainVegetable/26": "zoldsegek/vegyes-salata",
  "mainVegetable/27": "zoldsegek/feherrepa",
  "mainVegetable/28": "zoldsegek/hagyma",
  "mainVegetable/29": "zoldsegek/zoldborso",
  "mainVegetable/30": "zoldsegek/paprika",
  "mainVegetable/31": "zoldsegek/burgonya",
  "mainVegetable/32": "zoldsegek/mungobab",
  "mainVegetable/33": "zoldsegek/retek",
  "mainVegetable/34": "zoldsegek/fejessalata",
  "mainVegetable/35": "zoldsegek/fodros-salata",
  "mainVegetable/36": "zoldsegek/jegsalata",
  "mainVegetable/37": "zoldsegek/piemonti-salata",
  "mainVegetable/38": "zoldsegek/rizs-salata",
  "mainVegetable/39": "zoldsegek/romai-salata",
  "mainVegetable/40": "zoldsegek/fiatal-salata",
  "mainVegetable/41": "zoldsegek/salata",
  "mainVegetable/42": "zoldsegek/madarsalata",
  "mainVegetable/43": "zoldsegek/rukkola",
  "mainVegetable/44": "zoldsegek/feketegyoker",
  "mainVegetable/45": "zoldsegek/tabbouleh",
  "mainVegetable/46": "zoldsegek/paradicsom",
  "mainVegetable/47": "zoldsegek/vajbab",
  "mainVegetable/48": "zoldsegek/csicseriborso",
  "mainVegetable/49": "zoldsegek/porehagyma",
  "mainVegetable/50": "zoldsegek/orias-sutotok",
  "mainVegetable/51": "zoldsegek/vorosbab",
  "mainVegetable/52": "zoldsegek/alma",
  "mainVegetable/53": "zoldsegek/gesztenye",
  "mainVegetable/54": "zoldsegek/aszalt-szilva",
  "mainVegetable/55": "zoldsegek",
  "mainVegetable/56": "zoldsegek/fekete-oliva",
  "mainVegetable/57": "zoldsegek/articsoka",
  "mainVegetable/58": "zoldsegek/pirospaprika",
  "mainVegetable/59": "zoldsegek/zoldbab",
  "mainVegetable/60": "zoldsegek/tavaszi-zoldsegek",
  "mainVegetable/61": "zoldsegek/ratatouille",
  "mainVegetable/62": "zoldsegek/kuszkusz",
  "mainVegetable/63": "zoldsegek/tajine",
  "mainVegetable/64": "zoldsegek/curry-zoldsegek",
  "mainVegetable/65": "zoldsegek/sargaborso",
  "mainVegetable/66": "zoldsegek",
  "mainVegetable/67": "zoldsegek/voroslencse",
  "mainVegetable/68": "zoldsegek/quinoa",
  "mainVegetable/69": "zoldsegek/tonkolybuza",
  "mainVegetable/70": "zoldsegek/bulgur",
  "mainVegetable/71": "zoldsegek/voroskaposzta",
  "mainVegetable/72": "zoldsegek/fodros-kel",
  "mainVegetable/73": "zoldsegek/turbolya",
  "mainVegetable/74": "zoldsegek/magok",
  "mainVegetable/75": "zoldsegek/huvelyesek",
  "mainVegetable/76": "zoldsegek/jamgyoker",
  "mainVegetable/77": "zoldsegek/sutotok",
  "mainVegetable/78": "zoldsegek/soska",
  "mainVegetable/79": "zoldsegek/bab",
  "mainVegetable/80": "zoldsegek/bebirepa",
  "mainVegetable/81": "zoldsegek/borso",
  "mainVegetable/82": "zoldsegek",
  "mainVegetable/83": "zoldsegek",
  "mainVegetable/84": "zoldsegek",
  "mainVegetable/85": "zoldsegek",
  "mainVegetable/86": "zoldsegek",
  "mainVegetable/87": "zoldsegek",
  "mainVegetable/88": "zoldsegek",
  "mainVegetable/89": "zoldsegek",
  "mainVegetable/90": "zoldsegek",
  "mainVegetable/91": "zoldsegek",
  "mainVegetable/92": "zoldsegek",
  "mainVegetable/93": "zoldsegek",
  "mainVegetable/94": "zoldsegek",
  "mainVegetable/95": "zoldsegek",
  "mainVegetable/96": "zoldsegek",
  "mainVegetable/97": "zoldsegek",
  "mainVegetable/98": "zoldsegek",
  "productRange": "termekcsalad",
  "productRange/4G_BIO": "termekcsalad",
  "productRange/4G_SRP": "termekcsalad",
  "productRange/CAN_A_POEL": "termekcsalad",
  "productRange/CAN_SEC_BI": "termekcsalad",
  "productRange/CAN_SEC_CO": "termekcsalad",
  "productRange/CAN_SEC_CU": "termekcsalad",
  "productRange/CAN_SEC_NA": "termekcsalad",
  "productRange/CAN_VAPEUR": "termekcsalad",
  "productRange/CAN_VEG_SA": "termekcsalad",
  "productRange/CAN_VEG_SR": "termekcsalad",
  "productRange/CLASSICVEG": "termekcsalad",
  "productRange/COLDVEGE": "termekcsalad",
  "productRange/COOKMUSH": "termekcsalad",
  "productRange/CRUDITES": "termekcsalad",
  "productRange/DE_NOS_PRO": "termekcsalad",
  "productRange/DOYMUSHACC": "termekcsalad",
  "productRange/DOYMUSHAPE": "termekcsalad",
  "productRange/DRYVEGE": "termekcsalad",
  "productRange/FROZENVEGE": "termekcsalad",
  "productRange/FRZ_ASTUCE": "termekcsalad",
  "productRange/FRZ_GRATIN": "termekcsalad",
  "productRange/FRZ_KELLO": "termekcsalad",
  "productRange/FRZ_LEG_CO": "termekcsalad",
  "productRange/FRZ_PUREES": "termekcsalad",
  "productRange/FRZ_VEG_BI": "termekcsalad",
  "productRange/FRZ_VEG_SR": "termekcsalad",
  "productRange/INDFROZVEG": "termekcsalad",
  "productRange/JEUNES_POU": "termekcsalad",
  "productRange/LAITUES": "termekcsalad",
  "productRange/LOOP": "termekcsalad",
  "productRange/LUNCH_BOWL": "termekcsalad",
  "productRange/MACHE_BASE": "termekcsalad",
  "productRange/MEL_LAITUE": "termekcsalad",
  "productRange/MUSHNATEMI": "termekcsalad",
  "productRange/MUSHNATENT": "termekcsalad",
  "productRange/MUSHNATEPA": "termekcsalad",
  "productRange/MUSHNATMIN": "termekcsalad",
  "productRange/MUSHROOMS": "termekcsalad",
  "productRange/SUNVEGE": "termekcsalad",
  "productRange/TRAIT_CRUD": "termekcsalad",
  "productRange/TRAIT_TABO": "termekcsalad",
  "productRange/TUS_RECETA": "termekcsalad",
  "productRange/WORLDVEGE": "termekcsalad",
  "productRange/PREPARED_VEG": "termekcsalad",
  "productRange/BEAN_SAUCE": "termekcsalad/bon-menu",
  "productRange/BEANS": "termekcsalad",
  "productRange/BIO": "termekcsalad/bio",
  "productRange/BOND_KIDS": "termekcsalad",
  "productRange/CAN_BIO": "termekcsalad",
  "productRange/CAN_SEC_PR": "termekcsalad",
  "productRange/CARTA_DELL": "termekcsalad",
  "productRange/CAN_PETITS": "termekcsalad",
  "productRange/CAN_BOCAL": "termekcsalad",
  "productRange/CEREAL_CAN": "termekcsalad",
  "productRange/CEREAL_FRZ": "termekcsalad",
  "productRange/CEREALI": "termekcsalad/cereali",
  "productRange/CEREALLEGR": "termekcsalad",
  "productRange/COCCOLE": "termekcsalad",
  "productRange/CORN": "termekcsalad/kukorica",
  "productRange/CREATIF": "termekcsalad/creatif",
  "productRange/FRANCAIS": "termekcsalad",
  "productRange/FRZ_FRY_MI": "termekcsalad",
  "productRange/FRZ_MELANG": "termekcsalad",
  "productRange/FRZ_POELEE": "termekcsalad",
  "productRange/INSALATE_D": "termekcsalad",
  "productRange/INSALATONA": "termekcsalad",
  "productRange/LE_REGIONA": "termekcsalad",
  "productRange/LEGUMIO": "termekcsalad/legumio",
  "productRange/MIXES_CORN": "termekcsalad",
  "productRange/MONO_VEGE": "termekcsalad",
  "productRange/MUSHROOMS  ": "termekcsalad/gomba",
  "productRange/NATURA_IN": "termekcsalad",
  "productRange/OTHER_VEG": "termekcsalad",
  "productRange/PEAS": "termekcsalad/borso",
  "productRange/READY_FROZ": "termekcsalad",
  "productRange/SOUPS": "termekcsalad",
  "productRange/SPINACH": "termekcsalad",
  "productRange/STEAM_CAN": "termekcsalad/vapeur",
  "productRange/STEAM_FRZ": "termekcsalad/vapeur",
  "productRange/STEAM_MIX": "termekcsalad",
  "productRange/STUZZICHIA": "termekcsalad",
  "productRange/TOUCHE": "termekcsalad",
  "productRange/TRAIT_SAL": "termekcsalad",
  "productRange/TUS_RECETA ": "termekcsalad",
  "productRange/VEG_TO_FRY": "termekcsalad",
  "productRange/VEGGIE": "termekcsalad",
  "productRange/FRZ_JUSTEA": "termekcsalad",
  "productRange/SALABIS": "termekcsalad",
  "productRange/BON_SENGAG": "termekcsalad",
  "productRange/CROUSTIS": "termekcsalad",
  "season": "evszakok",
  "season/1": "evszakok/nyar",
  "season/2": "evszakok/osz",
  "season/3": "evszakok/tel",
  "season/4": "evszakok/tavasz",
  "season/5": "evszakok",
  "technologie": "technologia",
  "technologie/AC01": "technologia/ambient",
  "technologie/AD01": "technologia/fagyasztott",
  "technologie/AG01": "technologia/friss",
  "technologie/AT01": "technologia/food-service",
  "pred-recipeTimingCook-facet": "fozes",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "fozes/0-15-perc",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "fozes/15-30-perc",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "fozes/30-45-perc",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "fozes/45-perc",
  "pred-recipeTimingPreparation-facet": "elokeszites",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "elokeszites/0-15-perc",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "elokeszites/15-30-perc",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "elokeszites/30-45-perc",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "elokeszites/45-perc",
  "pred-recipeCost-Facet": "koltseg",
  "pred-recipeCost-Facet/petit": "koltseg/olcso",
  "pred-recipeCost-Facet/moyen": "koltseg/kozepes",
  "pred-recipeCost-Facet/grand": "koltseg/draga",
  "recipeDifficulty": "nehezseg",
  "recipeDifficulty/1": "nehezseg/konnyu",
  "recipeDifficulty/2": "nehezseg/kozepes",
  "recipeDifficulty/3": "nehezseg/nehez",
  "recipeDishNumber": "vendeg",
  "recipeDishNumber/1": "vendeg/1",
  "recipeDishNumber/2": "vendeg/2",
  "recipeDishNumber/3": "vendeg/3",
  "recipeDishNumber/4": "vendeg/4",
  "recipeDishNumber/5": "vendeg/5",
  "recipeDishNumber/6": "vendeg/6",
  "recipeDishNumber/7": "vendeg/7",
  "recipeDishNumber/8": "vendeg/8",
  "productTheme": "termek-by-tema",
  "productTheme/ACC": "termek-by-tema/kiseret",
  "productTheme/BEA": "termek-by-tema/bab",
  "productTheme/BIS": "termek-by-tema/bab-in-martassal",
  "productTheme/BIO": "termek-by-tema/bio",
  "productTheme/CAN": "termek-by-tema/tartositott-elelmiszerek",
  "productTheme/CER": "termek-by-tema",
  "productTheme/CLS": "termek-by-tema/meno-klasszikusok",
  "productTheme/DLE": "termek-by-tema/zoldsegek",
  "productTheme/EDR": "termek-by-tema/fokozok-de-etkezes",
  "productTheme/ENT": "termek-by-tema/eloetelek",
  "productTheme/FRZ": "termek-by-tema/megfagyott",
  "productTheme/FSD": "termek-by-tema/salatakhoz",
  "productTheme/FSH": "termek-by-tema/kiadasok",
  "productTheme/ING": "termek-by-tema/osszetevok-for-my-receptek",
  "productTheme/JAR": "termek-by-tema",
  "productTheme/LBW": "termek-by-tema",
  "productTheme/LDF": "termek-by-tema/zoldseg-kereg",
  "productTheme/LEG": "termek-by-tema/a-huvelyesek",
  "productTheme/LGO": "termek-by-tema/legumio",
  "productTheme/LGR": "termek-by-tema/zoldseg-racsok",
  "productTheme/LGS": "termek-by-tema",
  "productTheme/MAI": "termek-by-tema/a-de",
  "productTheme/MUS": "termek-by-tema/gomba",
  "productTheme/NEW": "termek-by-tema/uj-termekek",
  "productTheme/PDH": "termek-by-tema/lapos-konyha-of-zoldseg-szaraz",
  "productTheme/PDL": "termek-by-tema/kosar-of-zoldseg",
  "productTheme/PHR": "termek-by-tema/teszta-es-rizs-de-huvelyes",
  "productTheme/PLP": "termek-by-tema/main-tal",
  "productTheme/RAL": "termek-by-tema/rice-to-zoldseg",
  "productTheme/RDM": "termek-by-tema/keszetelek-",
  "productTheme/SAL": "termek-by-tema/all-in-my-salata",
  "productTheme/SDB": "termek-by-tema/salata-talak",
  "productTheme/SNK": "termek-by-tema/nassolas",
  "productTheme/SUP": "termek-by-tema/leves",
  "productTheme/TEX": "termek-by-tema/tex-mex",
  "productTheme/VGP": "termek-by-tema/novenyi-protein",
  "recipeTheme": "bevetel-per-tem",
  "recipeTheme/01": "bevetel-per-tem/unnepi-receptek",
  "recipeTheme/02": "bevetel-per-tem/eloetel-es-snack",
  "recipeTheme/03": "bevetel-per-tem/salatak-es-snack",
  "recipeTheme/04": "bevetel-per-tem/leves",
  "recipeTheme/05": "bevetel-per-tem/quiche-pie-and-csobensultek",
  "recipeTheme/06": "bevetel-per-tem/specialis-gyermek",
  "recipeTheme/07": "bevetel-per-tem/desszertek",
  "recipeTheme/08": "bevetel-per-tem/vegetarianusok",
  "recipeTheme/09": "bevetel-per-tem/kiseroi",
  "recipeTheme/10": "bevetel-per-tem/jon-from-mashol",
  "recipeTheme/11": "bevetel-per-tem/parolt",
  "recipeTheme/12": "bevetel-per-tem/salatak-es-barbecue",
  "recipeTheme/13": "bevetel-per-tem/snack-es-fingerfood",
  "recipeTheme/14": "bevetel-per-tem/foetelek",
  "recipeTheme/15": "bevetel-per-tem/desszertek-es-pekaru",
  "recipeTheme/16": "bevetel-per-tem/input-and-leves",
  "recipeTheme/17": "bevetel-per-tem/salatak",
  "recipeTheme/18": "bevetel-per-tem/golyozas",
  "recipeTheme/19": "bevetel-per-tem/levesek",
  "recipeTheme/20": "bevetel-per-tem/etelek",
  "recipeTheme/21": "bevetel-per-tem/martas",
  "recipeTheme/22": "bevetel-per-tem/lakas-egyedi",
  "recipeTheme/23": "bevetel-per-tem/mas-etelek",
  "recipeTheme/24": "bevetel-per-tem/etelek-kereg",
  "recipeTheme/25": "bevetel-per-tem",
  "recipeTheme/26": "bevetel-per-tem",
  "recipeTheme/27": "bevetel-per-tem",
  "recipeTheme/28": "bevetel-per-tem",
  "recipeTheme/33": "bevetel-per-tem/lencsevel",
  "recipeTheme/34": "bevetel-per-tem/karfiollal",
  "recipeTheme/35": "bevetel-per-tem/burgonyaval",
  "recipeTheme/36": "bevetel-per-tem/sargarepaval",
  "recipeTheme/37": "bevetel-per-tem/spenottal-",
  "recipeTheme/38": "bevetel-per-tem/paprikaval-",
  "recipeTheme/39": "bevetel-per-tem/gombaval",
  "recipeTheme/40": "bevetel-per-tem/zoldbabbal",
  "recipeTheme/41": "bevetel-per-tem/kukoricaval",
  "recipeTheme/42": "bevetel-per-tem/borsoval-",
  "recipeTheme/43": "bevetel-per-tem/vorosbabbal",
  "recipeTheme/44": "bevetel-per-tem/babbal-",
  "recipeTheme/45": "bevetel-per-tem/csicseriborsoval",
  "recipeTheme/46": "bevetel-per-tem/brokkolival",
  "pred-particularite": "food-habits",
  "pred-particularite/Sans%20conservateur": "food-habits/konzervativ-nelkul",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "food-habits",
  "pred-particularite/Sans%20colorant": "food-habits/szinezek-nelkul",
  "pred-particularite/Sans%20sucre%20ajout%E9": "food-habits/nem-cukor-felvetel",
  "pred-particularite/Sans%20sel%20ajout%E9": "food-habits/nem-so-hozzaadott",
  "pred-particularite/Sans%20additif": "food-habits/adalekanyag-nelkul",
  "pred-particularite/": "food-habits/so-termeszetben-jelen",
  "pred-particularite/Sans%20lactose": "food-habits/laktoz",
  "pred-particularite/Sans%20gluten": "food-habits/siker",
  "pred-particularite/V%E9g%E9tarien": "food-habits/vegetarianus",
  "pred-particularite/V%E9g%E9talien": "food-habits/vegan",
  "pred-particularite/Sans%20sulfite": "food-habits",
  "pred-particularite/A%20la%20vapeur": "food-habits/gozben-parolt",
  "pred-particularite/Sans%20condiment": "food-habits",
  "cultureType": "kultura-tipusa",
  "cultureType/Bio": "kultura-tipusa/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "kultura-tipusa/novenyvedoszer-maradvany-mentes",
  "cultureType/Sans%20OGM": "kultura-tipusa/gmo-mentes",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "food-habits/vegetarianus",
  "pred-particularite/recipeVeggie": "food-habits/vegetarianus",
  "pred-particularite/recipeGlutenfree": "food-habits/glutenmentes",
  "pred-particularite/recipeLactosefree": "food-habits/laktoz-nelkul"
};
